import { Component } from 'react';
import dateUtils from '../common/utilities/DateUtilities';
import { DateRangePicker } from "react-date-range";
import 'react-date-range/dist/styles.css'; // main style file
import 'react-date-range/dist/theme/default.css'; // theme css file
import {
    addDays, subDays, endOfDay, startOfDay, startOfMonth, endOfMonth, addMonths,
    startOfWeek, endOfWeek, isSameDay, differenceInCalendarDays, addYears, startOfYear, endOfYear,
} from 'date-fns';
import { TABLE_ATTRIBUTE_TYPES } from '../../settings/constants/types';

class DateTimeFilter extends Component {

    state = {
        visible: true,
        dateRange: {
            startDate: new Date(),
            endDate: addDays(new Date(), 0),
            key: 'selection'
        }
    };


    reactRangeCalendar = (labelData, dateOptions) => {

        const { visible, dateRange } = this.state;

        const handleDateChange = (ranges) => {
            const { startDate, endDate } = ranges.selection;
            this.setState({ dateRange: ranges.selection, visible: false });
        };

        switch (labelData.toUpperCase()) {
            case "AFTER":
                return (
                    <DateRangePicker
                        ranges={[dateRange]}
                        onChange={handleDateChange}
                        months={1}
                        direction="horizontal"
                        rangeColors={['#3b82f6']}
                        showSelectionPreview={true}
                        moveRangeOnFirstSelection={false}
                    />
                );

            case "BEFORE":
                return (
                    <DateRangePicker
                        ranges={[dateRange]}
                        onChange={handleDateChange}
                        months={1}
                        direction="horizontal"
                        rangeColors={['#3b82f6']}
                        showSelectionPreview={true}
                        moveRangeOnFirstSelection={false}
                    />
                );

            case "CUSTOM RANGE":
                return (
                    <DateRangePicker
                        ranges={[dateRange]}
                        onChange={handleDateChange}
                        months={1}
                        direction="horizontal"
                        rangeColors={['#3b82f6']}
                        showSelectionPreview={true}
                        moveRangeOnFirstSelection={false}
                    />
                );
        }
    }

    getDateTimeOperatorByTimeStamp = (label) => {
        switch (label.toUpperCase()) {
            // case "TODAY":
            //     return [startOfDay(new Date())];

            // case "YESTERDAY":
            //     return [startOfDay(addDays(new Date(), -1))];

            // case "THIS WEEK":
            //     return [startOfWeek(new Date()), endOfWeek(new Date())]

            case "TODAY":
                return [(new Date())];

            case "YESTERDAY":
                return [(addDays(new Date(), -1))];

            case "THIS WEEK":
                return [(new Date()), endOfWeek(new Date())];

            case "LAST WEEK":
                return [startOfWeek(addDays(new Date(), -7)), endOfWeek(addDays(new Date(), -7))];

            case "LAST TWO WEEK":
                return [startOfWeek(addDays(new Date(), -14)), endOfWeek(addDays(new Date(), -7))];

            case "THIS MONTH":
                return [startOfMonth(new Date()), endOfMonth(new Date())];

            case "LAST MONTH":
                return [startOfMonth(addMonths(new Date(), -1)), endOfMonth(addMonths(new Date(), -1))];

            case "LAST TWO MONTH":
                return [startOfMonth(addMonths(new Date(), -2)), endOfMonth(addMonths(new Date(), -1))];

            case "AFTER":
                return this.reactRangeCalendar("AFTER");
            default:
                break;
        }
    }

    convertFormattedDatTimeByTimeStamp = (label, type) => {
        var resultedDate;
        var newData = this.getDateTimeOperatorByTimeStamp(label);
        if (type === TABLE_ATTRIBUTE_TYPES.DATE) {
            if (newData.length === 1) {
                resultedDate = dateUtils.getCalendarFormattedDateByTimeStamp(newData[0])
            }

            if (newData.length === 2) {
                resultedDate = `${dateUtils.getCalendarFormattedDateByTimeStamp(newData[0])}#${dateUtils.getCalendarFormattedDateByTimeStamp(newData[1])}`;
            }

            return resultedDate;
        } else if (type === TABLE_ATTRIBUTE_TYPES.DATETIME) {
            if (newData.length === 1) {
                resultedDate = dateUtils.getFormattedDateTimeForDateTimeColumns(newData[0])
            }

            if (newData.length === 2) {
                resultedDate = `${dateUtils.getFormattedDateTimeForDateTimeColumns(newData[0])}#${dateUtils.getFormattedDateTimeForDateTimeColumns(newData[1])}`;
            }
        }
        return resultedDate;
    }
}

export default new DateTimeFilter();